import http from './http';
import { handleResponse } from '@/shared/utils/promise-helpers';

export default {
  getAgentById(identifier) {
    return http.get(`/agents/${identifier}`);
  },

  timeInformations(identifier) {
    if (identifier) {
      return http.get(`/agents/${identifier}/informations/time`);
    }
    return new Promise((resolve) => resolve(true));
  },

  getAgentsAvailableByWhatsappQueue(id, agentId) {
    return http.get(`/queues/whatsapp/${id}/agents-available`, {
      params: { agentId },
    });
  },

  getAgentsAvailableByWhatsappCampaign(id, agentId) {
    return http.get(`/campaigns/whatsapp/${id}/agents-available`, {
      params: { agentId },
    });
  },

  async fetchAgentById(id) {
    try {
      const { data } = await http.get(`/agents/${id}`);
      return data;
    } catch (err) {
      throw err;
    }
  },

  availableAgents() {
    return http.get('/agents/available');
  },

  getAgentHistory(parameters) {
    return http.get('/agents/history', { params: parameters });
  },

  updateAgentDefaultCampaign(identifier, channel, campaign) {
    return http.put(`/agents/${identifier}/set-campaign-default`, {
      agentId: identifier,
      channel,
      campaignId: campaign,
    });
  },

  getOrgUnitInformation(orgUnitId) {
    return http.get(`/org-unit/${orgUnitId}`);
  },

  changeAgentPassword(identifier, newPassword) {
    return http.put(`/agents/${identifier}/change-password`, {
      agentId: identifier,
      password: newPassword,
    });
  },
  updateAckCallVolume(agentId, volume) {
    return http.put(`/agents/${agentId}/ackcall-volume`, { agentId, volume });
  },
  updateWebRTCAutoReconnect(agentId, webRtcAutoReconnect) {
    return http.put(`/agents/${agentId}/webrtc-auto-reconnect`, {
      agentId,
      webRtcAutoReconnect,
    });
  },
  removeAgentAbsentStatus(agentId) {
    return http.put(`/agents/${agentId}/remove-absent-mode`);
  },
};

export const getStatusAgentChannels = (agentId) =>
  http.get(`/agents/${agentId}/status`).then(handleResponse);

export const putWhatsappNotification = (agentId, notify) => {
  return http.put(`/agents/${agentId}/whatsapp-notify-message`, {
    agentId,
    notify,
  });
};

export const putChatNotification = (agentId, notify) => {
  return http.put(`/agents/${agentId}/chat-notify-message`, {
    agentId,
    notify,
  });
};

export const putVoiceNotificationConnectionLost = (agentId, notify) => {
  return http.put(`/agents/${agentId}/voice-notify-connection-lost`, {
    agentId,
    notify,
  });
};
